module.exports = __webpack_public_path__ + "img/icone_email.8b8b9b04.svg";